import { Button } from '@/components/ui/button'
import { format, isSameDay } from 'date-fns'
import { ptBR } from 'date-fns/locale'
import { Calendar } from 'lucide-react'

export function BookingDateSelection({ flow }: { flow: any }) {
  return (
    <div className="space-y-4 animate-in fade-in slide-in-from-bottom-4">
      <h2 className="text-lg font-semibold flex items-center gap-2">
        <Calendar className="w-5 h-5 text-blue-500" />
        Para quando?
      </h2>
      
      <div className="grid grid-cols-2 gap-3 overflow-y-auto max-h-[300px] pr-2">
        {flow.days.map((d: Date) => {
          const isSelected = isSameDay(d, flow.date)
          return (
            <button
              key={d.toISOString()}
              onClick={() => {
                flow.setDate(d)
                flow.setTime('')
              }}
              className={`text-center p-3 rounded-xl border transition-all duration-300 ${
                isSelected 
                  ? 'border-blue-500 bg-blue-500/10 shadow-[0_0_15px_-5px_rgba(59,130,246,0.5)]' 
                  : 'border-slate-800 hover:border-slate-700 bg-slate-800/50'
              }`}
            >
              <div className={`text-sm font-medium capitalize ${isSelected ? 'text-blue-400' : 'text-slate-400'}`}>
                {format(d, 'EEEE', { locale: ptBR })}
              </div>
              <div className={`text-xl font-bold mt-1 ${isSelected ? 'text-slate-100' : 'text-slate-300'}`}>
                {format(d, 'dd MMM', { locale: ptBR })}
              </div>
            </button>
          )
        })}
      </div>

      <div className="pt-4 flex gap-2">
        <Button variant="outline" className="w-full" onClick={() => flow.setStep(3)}>
          Voltar
        </Button>
        <Button className="w-full" onClick={() => flow.setStep(5)}>
          Ver horários
        </Button>
      </div>
    </div>
  )
}
